import React, { useEffect, useState } from 'react';
import './supNotification.css';
import { toast } from 'react-toastify';
import { supAppUserStats, supNotificationHistory, supSendNotification } from '../../api/supportAdmin';
import { useNavigate } from 'react-router-dom';

function SupNotification() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        totalUsers: 0,
        androidUsers: 0,
        iosUsers: 0,
        activeUsers: 0
    });
    const [formData, setFormData] = useState({
        audience: 'all',
        type: 'OFFERS',
        title: '',
        body: '',
        screen: '',
        searchKeyword: '',
        image: '',
        sendType: ''
    });
    const [recentNotifications, setRecentNotifications] = useState([]);

    const getStats = async () => {
        try {
            const response = await supAppUserStats();
            setStats(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getRecentNotifications = async () => {
        try {
            const response = await supNotificationHistory({
                limit: 5,
                offset: 0
            });

            setRecentNotifications(response.data.notifications);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getStats();
        getRecentNotifications();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const sendNotification = async () => {
        try {
            if (!formData.title.trim()) {
                return toast.warning('Title is required');
            }

            if (!formData.body.trim()) {
                return toast.warning('Message is required');
            }

            setLoading(true);

            const response = await supSendNotification(formData);
            if (response.status === 200) {
                toast.success(response?.data?.message || 'Notification sent');

                setFormData({
                    audience: 'all',
                    type: 'OFFERS',
                    title: '',
                    body: '',
                    screen: 'offers',
                    image: '',
                    sendType: 'now'
                });
                getRecentNotifications();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Failed to send notification');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='notification-dashboard'>
                <div className='page-header'>
                    <h2>Send Push Notification</h2>
                </div>
                <div className='statsGrid'>
                    <div className='statCard'>
                        <h4>Total Users</h4>
                        <h2>{stats.totalUsers}</h2>
                    </div>

                    <div className='statCard'>
                        <h4>Android Users</h4>
                        <h2>{stats.androidUsers}</h2>
                    </div>

                    <div className='statCard'>
                        <h4>IOS Users</h4>
                        <h2>{stats.iosUsers}</h2>
                    </div>

                    <div className='statCard'>
                        <h4>Active Users</h4>
                        <h2>{stats.activeUsers}</h2>
                    </div>
                </div>
                <div className='dashboard-grid'>
                    {/* FORM */}
                    <div className='notification-form-card'>
                        <h3>Notification Details</h3>

                        <div className='form-group'>
                            <label>Audience</label>

                            <select name='audience' value={formData.audience} onChange={handleChange}>
                                <option value='all'>All Users</option>
                                <option value='android'>Android Users</option>
                                <option value='ios'>iOS Users</option>
                            </select>
                        </div>

                        <div className='form-row'>
                            <div className='form-group'>
                                <label>Notification Type</label>

                                <select name='type' value={formData.type} onChange={handleChange}>
                                    <option value='OFFERS'>OFFERS</option>
                                    <option value='TRIPS'>TRIPS</option>
                                    <option value='BOOKINGS'>BOOKINGS</option>
                                    <option value='GENERAL'>GENERAL</option>
                                </select>
                            </div>

                            {/* <div className='form-group'>
                            <label>Screen</label>

                            <select name='screen' value={formData.screen} onChange={handleChange}>
                                <option value='home'>Home</option>
                                <option value='offers'>Offers</option>
                                <option value='tripDetails'>Trip Details</option>
                                <option value='bookingDetails'>Booking Details</option>
                            </select>
                        </div> */}
                        </div>

                        <div className='form-group'>
                            <label>Title</label>

                            <input
                                type='text'
                                name='title'
                                value={formData.title}
                                onChange={handleChange}
                                placeholder='Adventure Trips Await 🚀'
                                maxLength={100}
                            />
                        </div>

                        <div className='form-group'>
                            <label>Message</label>

                            <textarea
                                rows={5}
                                name='body'
                                value={formData.body}
                                onChange={handleChange}
                                placeholder='Explore thrilling adventures this weekend...'
                                maxLength={500}
                            />
                        </div>
                        {formData.type === 'OFFERS' && (
                            <div className='form-group'>
                                <label>Search Keyword</label>

                                <input
                                    type='text'
                                    name='searchKeyword'
                                    value={formData.searchKeyword}
                                    onChange={handleChange}
                                    placeholder='Enter search key to which it should navigate'
                                    maxLength={100}
                                />
                            </div>
                        )}
                        <div className='form-group'>
                            <label>Image URL (Optional)</label>

                            <input
                                type='text'
                                name='image'
                                value={formData.image}
                                onChange={handleChange}
                                placeholder='https://...'
                            />
                        </div>

                        {/* <div className='form-group'>
                        <label>Send Option</label>

                        <div className='radio-group'>
                            <label>
                                <input
                                    type='radio'
                                    name='sendType'
                                    value='now'
                                    checked={formData.sendType === 'now'}
                                    onChange={handleChange}
                                />
                                Send Now
                            </label>

                            <label>
                                <input
                                    type='radio'
                                    name='sendType'
                                    value='schedule'
                                    checked={formData.sendType === 'schedule'}
                                    onChange={handleChange}
                                />
                                Schedule Later
                            </label>
                        </div>
                    </div> */}

                        <button className='send-btn' disabled={loading} onClick={sendNotification}>
                            {loading ? 'Sending...' : 'Send Notification'}
                        </button>
                    </div>

                    {/* PREVIEW */}
                    <div className='preview-card'>
                        <h3>Live Preview</h3>

                        <div className='mobile-preview'>
                            <div className='notification-preview-box'>
                                <strong>{formData.title || 'Adventure Trips Await 🚀'}</strong>

                                <p>
                                    {formData.body ||
                                        'Explore thrilling adventures this weekend and get exciting offers.'}
                                </p>
                            </div>
                        </div>

                        <div className='summary-card'>
                            <h4>Summary</h4>

                            <div className='summary-row'>
                                <span>Audience</span>
                                <strong>{formData.audience}</strong>
                            </div>

                            <div className='summary-row'>
                                <span>Type</span>
                                <strong>{formData.type}</strong>
                            </div>

                            {formData.screen !== '' && (
                                <div className='summary-row'>
                                    <span>Screen</span>
                                    <strong>{formData.screen}</strong>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className='recent-notification-table'>
                <div className='recent-table-header'>
                    <h3>Recent Notifications</h3>

                    <button className='view-all-btn' onClick={() => navigate('/support/admin/notifications/history')}>
                        View All →
                    </button>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Type</th>
                            <th>Audience</th>
                            <th>Sent By</th>
                            <th>Sent On</th>
                            <th>Status</th>
                            <th>Sent To</th>
                        </tr>
                    </thead>

                    <tbody>
                        {recentNotifications.map((row) => (
                            <tr key={row._id}>
                                <td>{row.title}</td>

                                <td>
                                    <span className='type-chip'>{row.type}</span>
                                </td>

                                <td>
                                    {row.audience === 'all'
                                        ? 'All Users'
                                        : row.audience === 'android'
                                          ? 'Android Users'
                                          : 'iOS Users'}
                                </td>

                                <td>{row?.sentBy?.name}</td>

                                <td>{new Date(row.createdAt).toLocaleString()}</td>

                                <td>
                                    <span className={`status-chip ${row.status}`}>{row.status}</span>
                                </td>

                                <td>{row.successCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default SupNotification;
